import { PagerObject } from "../../types/DataFetchingTypes";
import { Organization } from "../../types/OrganizationTypes";
import { safeDELETE, safeGET, safePOST } from "./SafeClient";

export function listOrgs(abort?: any): Promise<PagerObject<Organization[]>> {
    return safeGET(`/api/organization`, abort);
}

export function createOrg(orgName: string, abort?: any): Promise<Organization> {
    return safePOST(`/api/organization/`, { orgName }, abort);
}

export function deleteOrg(orgId: number, abort?: any): Promise<string> {
    return safeDELETE(`/api/organization/${orgId}`, undefined, abort);
}

export function getOrg(id: number, abort?: any): Promise<Organization> {
    return safeGET(`/api/organization/${id}`, abort);
}
